import { exhaustiveSwitchWithDefault } from "@faire/web/common/exhaustiveSwitchWithDefault";
import { cn } from "@faire/web/tools/cn";

export enum TrackingTargetType {
  COMPONENT = "COMPONENT",
  COMPONENT_GROUP = "COMPONENT_GROUP",
  ICON = "ICON",
}

export const getTrackingCls = (targetType: TrackingTargetType) => {
  switch (targetType) {
    case TrackingTargetType.COMPONENT:
      return "fs-component";
    case TrackingTargetType.COMPONENT_GROUP:
      return "fs-component-group";
    case TrackingTargetType.ICON:
      return "fs-icon";
    default:
      return exhaustiveSwitchWithDefault("")(targetType);
  }
};

export const componentCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getTrackingCls(TrackingTargetType.COMPONENT));

export const componentGroupCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getTrackingCls(TrackingTargetType.COMPONENT_GROUP));

export const iconCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getTrackingCls(TrackingTargetType.ICON));
